import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFirebaseAuthToken } from "../../helpers/firebase_helper";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

// Get theme for user
export const getThemeForUser = createAsyncThunk(
    "theme/getThemeForUser",
    async (request = {}, { rejectWithValue }) => {
        try {
            const token = await getFirebaseAuthToken();
            const response = await fetch(`${API_BASE}/dashboard/theme`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `${token}`,
                },
                body: JSON.stringify(request),
            });

            if (!response.ok) {
                const errorData = await response.json();
                return rejectWithValue(errorData);
            }

            const res = await response.json();
            return res;
        } catch (error) {
            return rejectWithValue(error.toString());
        }
    }
);

// Save theme (create or update)
export const saveTheme = createAsyncThunk(
    "theme/saveTheme",
    async (request, { rejectWithValue }) => {
        try {
            const token = await getFirebaseAuthToken();
            const response = await fetch(`${API_BASE}/dashboard/theme/save`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `${token}`,
                },
                body: JSON.stringify(request),
            });

            if (!response.ok) {
                const errorData = await response.json();
                return rejectWithValue(errorData);
            }

            const res = await response.json();
            return res;
        } catch (error) {
            return rejectWithValue(error.toString());
        }
    }
);

// Get themes by owner
export const getThemesByOwner = createAsyncThunk(
    "theme/getThemesByOwner",
    async (ownerId, { rejectWithValue }) => {
        try {
            const token = await getFirebaseAuthToken();
            const response = await fetch(`${API_BASE}/dashboard/theme/${ownerId}`, {
                method: "GET",
                headers: {
                    Authorization: `${token}`,
                },
            });

            if (!response.ok) {
                const errorData = await response.json();
                return rejectWithValue(errorData);
            }

            const res = await response.json();
            return res;
        } catch (error) {
            return rejectWithValue(error.toString());
        }
    }
);

// Delete theme
export const deleteTheme = createAsyncThunk(
    "theme/deleteTheme",
    async (themeId, { rejectWithValue }) => {
        try {
            const token = await getFirebaseAuthToken();
            const response = await fetch(`${API_BASE}/dashboard/theme/${themeId}`, {
                method: "DELETE",
                headers: {
                    Authorization: `${token}`,
                },
            });

            if (!response.ok) {
                const errorData = await response.json();
                return rejectWithValue(errorData);
            }

            const res = await response.json();
            return res;
        } catch (error) {
            return rejectWithValue(error.toString());
        }
    }
);

// Set default theme
export const setDefaultTheme = createAsyncThunk(
    "theme/setDefaultTheme",
    async (request, { rejectWithValue }) => {
        try {
            const token = await getFirebaseAuthToken();
            const response = await fetch(`${API_BASE}/dashboard/theme/set-default`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `${token}`,
                },
                body: JSON.stringify(request),
            });

            if (!response.ok) {
                const errorData = await response.json();
                return rejectWithValue(errorData);
            }

            const res = await response.json();
            return res;
        } catch (error) {
            return rejectWithValue(error.toString());
        }
    }
);

